export default __webpack_public_path__ + "9b983852ff9266b3fd8ddd809c73647d.svg";